var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniDivisionBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96438 0.380041C10.1927 0.248198 10.4741 0.248197 10.7024 0.380041L18.913 5.12042C19.1414 5.25226 19.2821 5.49592 19.2821 5.75961V15.2404C19.2821 15.5041 19.1414 15.7477 18.913 15.8796L10.7024 20.6199C10.4741 20.7518 10.1927 20.7518 9.96438 20.6199L1.7538 15.8796C1.52544 15.7477 1.38477 15.5041 1.38477 15.2404V5.75961C1.38477 5.49592 1.52544 5.25226 1.7538 5.12042L9.96438 0.380041Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3334 1.87148L2.86091 6.18573V14.8142L10.3334 19.1285L17.8059 14.8142V6.18573L10.3334 1.87148ZM10.7024 0.380041C10.4741 0.248197 10.1927 0.248198 9.96438 0.380041L1.7538 5.12042C1.52544 5.25226 1.38477 5.49592 1.38477 5.75961V15.2404C1.38477 15.5041 1.52544 15.7477 1.7538 15.8796L9.96438 20.6199C10.1927 20.7518 10.4741 20.7518 10.7024 20.6199L18.913 15.8796C19.1414 15.7477 19.2821 15.5041 19.2821 15.2404V5.75961C19.2821 5.49592 19.1414 5.25226 18.913 5.12042L10.7024 0.380041Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniDivisionBadge);
export default __webpack_public_path__ + "static/media/mini-division-badge.a0fd87051e0235ff248105674c29c794.svg";
export { ForwardRef as ReactComponent };